import 'react-virtualized-select/styles.css';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import axios from 'axios';
import classNames from 'classnames';
import VirtualizedSelect from 'react-virtualized-select';

import LoadingSpinner from 'js/components/loading_spinner';

// Approximate number of tickets that one line can fit
const NUMBER_OF_SYMBOLS_IN_LINE = 62;
// Default option's height that is used in react-virtualized-select
const DEFAULT_OPTION_HEIGHT = 35;

export default class BrandCampaignSelect extends Component {
    static propTypes = {
        onComplete: PropTypes.func,
        showSubmitButton: PropTypes.bool, // optionally hide submit button if composing this component
        campaignFuzzySearchUrl: PropTypes.string,
        children: PropTypes.string, // submit button text
        track: PropTypes.any, // pays attention to this prop, re-enabling if it changes
        idempotent: PropTypes.bool.isRequired, // can this action be performed repeatedly?
        disabled: PropTypes.bool, // overrides "track," disabling all parts of this component
        disabledReason: PropTypes.string, // an optional reason that the component was disabled
        handleCampaignSelect: PropTypes.func, // sends campaign-id events here when selected
        loadOnMount: PropTypes.bool.isRequired,
        campaigns: PropTypes.arrayOf(
            // optionally mount with campaigns
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                value: PropTypes.number.isRequired
            })
        )
    };

    static defaultProps = {
        showSubmitButton: true,
        loadOnMount: true,
        idempotent: false,
        handleCampaignSelect: () => {},
        onComplete: () => {}
    };

    constructor(props) {
        super(props);

        this.state = {
            campaign_id: null,
            campaigns: props.campaigns || [],
            transmitting: false,
            submitDisabled: true
        };
    }

    UNSAFE_componentWillMount() {
        if (this.props.loadOnMount) {
            this.setState({transmitting: true}, () => {
                axios.get(this.props.campaignFuzzySearchUrl).then(({data}) => {
                    this.setState({
                        transmitting: false,
                        campaigns: data
                    });
                });
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const doesNotEqual = R.complement(R.equals);

        if (doesNotEqual(nextProps.track, this.props.track)) {
            this.setState({submitDisabled: false});
        }

        if (doesNotEqual(nextProps.campaigns, this.props.campaigns)) {
            this.setState({campaigns: nextProps.campaigns});
        }
    }

    /**
     * @param {Object} campaignOption
     * @memberof BrandCampaignSelect
     */
    onCampaignSelect = campaignOption => {
        const {handleCampaignSelect} = this.props;
        if (!campaignOption) return;
        const campaignId = campaignOption.value;

        this.setState({campaign_id: campaignId, submitDisabled: false}, () => {
            handleCampaignSelect(campaignId);
        });
    };

    /**
     * @param {number} campaignId
     * @param {Event} e
     * @memberof BrandCampaignSelect
     */
    handleComplete = R.curry((campaignId, e) => {
        this.setState({transmitting: true, submitDisabled: !this.props.idempotent}, () => {
            this.props.onComplete(campaignId);
            this.setState({transmitting: false});
        });
    });

    displayTransmittingSpinner = () => {
        if (this.state.transmitting) {
            return <LoadingSpinner additionalClasses="fa-2x" />;
        }
    };

    displayCampaignSelect = () => {
        const {campaign_id, campaigns} = this.state;
        const value = R.find(R.propEq('value', campaign_id), campaigns);

        return (
            <VirtualizedSelect
                className="add-to-hopper-select"
                name="campaign_id"
                value={value}
                disabled={false}
                options={campaigns}
                onChange={this.onCampaignSelect}
                optionHeight={this.calculateOptionHeight}
            />
        );
    };

    calculateOptionHeight = ({option}) => {
        // increase height of option for each NUMBER_OF_SYMBOLS_IN_LINE by DEFAULT_OPTION_HEIGHT
        return (Math.ceil(option.label.length / NUMBER_OF_SYMBOLS_IN_LINE) || 1) * DEFAULT_OPTION_HEIGHT;
    }

    displaySubmitButton = () => {
        const {children, showSubmitButton, disabled} = this.props;
        const {campaign_id, submitDisabled} = this.state;

        if (R.not(showSubmitButton)) {
            return null;
        }

        const isDisabled = submitDisabled || disabled || R.isNil(campaign_id);

        const classes = classNames('btn btn-success', {
            disabled: isDisabled
        });

        const onClick = isDisabled ? null : this.handleComplete(campaign_id, R.__);

        return (
            <span className={classes} onClick={onClick}>
                {children}
            </span>
        );
    };

    displayDisabledReason = () => {
        const {disabled, disabledReason} = this.props;
        return disabled && disabledReason && <div>{disabledReason}</div>;
    };

    render() {
        const campaignSelect = this.displayCampaignSelect();
        const submitButton = this.displaySubmitButton();
        const disabledReason = this.displayDisabledReason();
        const spinner = this.displayTransmittingSpinner();

        return (
            <div>
                {disabledReason}
                <div className="col-xs-11">{campaignSelect} </div>
                <div className="col-xs-1">{spinner}</div>
                <br />
                <br />
                {submitButton}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./publisher_leads/brand_campaign_select.js